import { useState, useCallback } from "react";

// Persists AI-generated focus areas across mounts of CustomStep3_FocusAreas.
// Lifting state here means back-navigation doesn't re-trigger the OpenAI call.
// selectedFoci and error remain local to the component (navigation-independent).

export function useFocusAreasState() {
  const [focusAreasCache, setFocusAreasCache] = useState({
    focusAreas: [],          // last successful generation result
    generationAttempts: 0,
    previousGenerations: [], // last 3 batches of titles, used for dedup on regen
  });

  const updateFocusAreasCache = useCallback((updates) => {
    setFocusAreasCache((prev) => ({ ...prev, ...updates }));
  }, []);

  // Reset when user returns to step 1 — JD may change, so cached areas are stale
  const resetFocusAreasCache = useCallback(() => {
    setFocusAreasCache({ focusAreas: [], generationAttempts: 0, previousGenerations: [] });
  }, []);

  return { focusAreasCache, updateFocusAreasCache, resetFocusAreasCache };
}
